var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#81D61E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9399 10.125H13.4399V7.875H15.6899V6.375H13.4399V4.125H11.9399V6.375H9.68994V7.875H11.9399V10.125ZM8.93994 16.875C8.11494 16.875 7.44744 17.55 7.44744 18.375C7.44744 19.2 8.11494 19.875 8.93994 19.875C9.76494 19.875 10.4399 19.2 10.4399 18.375C10.4399 17.55 9.76494 16.875 8.93994 16.875ZM16.4399 16.875C15.6149 16.875 14.9474 17.55 14.9474 18.375C14.9474 19.2 15.6149 19.875 16.4399 19.875C17.2649 19.875 17.9399 19.2 17.9399 18.375C17.9399 17.55 17.2649 16.875 16.4399 16.875ZM9.76494 13.125H15.3524C15.9149 13.125 16.4099 12.8175 16.6649 12.3525L19.5599 7.095L18.2549 6.375L15.3524 11.625H10.0874L6.89244 4.875H4.43994V6.375H5.93994L8.63994 12.0675L7.62744 13.8975C7.07994 14.9025 7.79994 16.125 8.93994 16.125H17.9399V14.625H8.93994L9.76494 13.125Z",
    fill: "#0B7340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartGreen);
export default __webpack_public_path__ + "static/media/cart-green.255da00cb3a3bbe3ab14c9527f78df8c.svg";
export { ForwardRef as ReactComponent };